import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'toggle' ]

  toggle(event) {
    event.preventDefault();
    this.toggleTargets.forEach(target => {
      target.classList.toggle(target.dataset.classname || 'is-active')
    });
  }

  on(event) {
    event.preventDefault();
    this.toggleTargets.forEach(target => {
      target.classList.add(target.dataset.classname || 'is-active')
    });
  }

  off(event) {
    event.preventDefault();
    this.toggleTargets.forEach(target => {
      target.classList.remove(target.dataset.classname || 'is-active')
    });
  }
}
